import { Component, OnInit } from '@angular/core';
import { NeproseService } from '../services/neprose.service';
import { SeoSocialShareData, SeoSocialShareService } from 'ngx-seo';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-our-services',
  templateUrl: './our-services.component.html',
  styleUrls: ['./our-services.component.css']
})
export class OurServicesComponent implements OnInit {
  adPlans = []

  seoData: SeoSocialShareData = {
    title:  'Neprose - Services',
    description: 'Your next real estate investment opportunity could be right around the corner.',
    image: environment.url+'/assets/logo.png',
    type: 'website'
  };

  constructor( private seo: SeoSocialShareService, private neproseService: NeproseService) { }

  ngOnInit(): void {
    this.seo.setData(this.seoData)
  }

}
